<template>
  <div :class="$style.item" @click="click">
    <img :class="$style.itemImg" :src="data.Image" />
    <div :class="$style.itemDetail">
      <div :class="$style.itemName" class="u-noWrapWithEllipsis" :title="data.Name">
        {{ data.Name }}
      </div>
      <div :class="$style.time">
        {{ data.ReceivedTime }}
      </div>
    </div>
    <div :class="$style.text">
      省<span :class="$style.money">￥{{ data.SavedMoney }}</span>
    </div>
  </div>
</template>

<script>
// Image: "https://i1.lifevccdn.com//upload/goods//upload/goods/D1704201923144854.jpg"
// ItemInfoId: 21599
// Name: "酵素洗衣液(超强洁净)"
// SalePrice: 49
export default {
  name: "ReceivedItem",
  props: {
    data: {}
  },
  // computed: {
  //   disabled() {
  //     return this.data.IsSoldOut || !this.data.IsCanReceive;
  //   }
  // },
  data() {
    return {};
  },
  methods: {
    click() {
      this.$emit("click", this.data);
    },
    action() {
      this.$emit("action", this.data);
    }
  }
};
</script>

<style lang="scss" module>
$page-width: 375;
@import "~style/tool";

.item {
  line-height: 1;
  overflow: hidden;
  padding: rem(4) 0 rem(5);
  display: flex;
  align-items: center;
}

.itemImg {
  width: rem(48);
  height: rem(48);
}

.itemDetail {
  margin-left: rem(7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
}
.itemName {
  width: rem(130);
  font-size: rem(11);
  color: rgba(51, 51, 51, 1);
  line-height: 1.2;
}
.time {
  margin-top: rem(8);
  font-size: rem(10);
  color: rgba(153, 153, 153, 1);
}

.text {
  margin-left: auto;
  font-size: rem(13);
  color: rgba(51, 51, 51, 1);
}
.money {
  font-size: rem(14);
  color: rgba(201, 80, 82, 1);
}
</style>
